import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from './api.service';
import { CommentsDialogComponent } from 'app/queue-box/comments-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class CancelApprovalService {

  constructor(
    private apiService: ApiService,
    private dialog: MatDialog
  ) {}

    cancelApproval(docId: number, modelName: string, onSuccess?: () => void) {
        const dialogRef = this.dialog.open(CommentsDialogComponent, {
            width: '400px',
            data: {
                title: 'Cancelation Request',
                message: 'Add comments (optional):',
                isRequired: false,
                action: 'Save',
            }
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                if (confirm('Do you want to cancel the approval?')) {
                    const postData = {
                        doc_id: docId,
                        model: modelName,
                        comments: result.comments
                    };
                    this.apiService.cancelApproval(postData).subscribe(
                        (res: any) => {
                            console.log(res);
                            alert(res.message);
                            if (onSuccess) {
                                onSuccess();
                            }
                        },
                        (error) => {
                            if (error?.error?.message) {
                                alert(error.error.message);
                            } else {
                                alert("Something went wrong!");
                            }
                        }
                    );
                }
            }
        });
    }
}